import { createContext, useState } from "react"
import API from "services/api"
import _ from "lodash"

export const ActivityLogContext = createContext({})

const ActivityLogProvider = (props) => {
	const [activitylogs, setActivityLogs] = useState([])
	const [logdetails, setLogDetails] = useState([])

	const getActivityLog = async (params) => {
		await API.getActivityLog(params)
			.then((res) => {
				const { data } = res
				let fdetail = data.map((x) => {
					if (x?.details) {
						let fparse = JSON.parse(x?.details)

						let fmap = fparse?.files?.map((y) => {
							return { file: y, ...x, detail: fparse }
						})

						return fmap
					}
				})
				let flatmap = _.flatMapDeep(fdetail)
				let _filter = flatmap?.filter((x) => x !== undefined)
				let _duplicate = _filter.filter((item, index, self) => {
					return self.findIndex((i) => i.file.url === item.file.url) === index
				})

				// setLogDetails(data)
				setLogDetails(_duplicate)
				setActivityLogs(data)
			})
			.catch((err) => console.log("err", err))
	}

	const postActivityLog = (sendData) => {
		return API.postActivityLog(sendData)
			.then((res) => {
				const { data } = res
				getActivityLog({ params: { filing: sendData?.filing } })
				return { status: 200, data: data?.data }
			})
			.catch((err) => {
				return { status: 404, data: err.message }
			})
	}

	const putActivityLog = (id, sendData) => {
		return API.putActivityLog(id, sendData)
			.then((res) => {
				const { data } = res
				getActivityLog()
				return { status: 200, data: data }
			})
			.catch((err) => {
				return { status: 404, data: err.message }
			})
	}

	const deleteActivityLog = (id) => {
		return API.deleteActivityLog(id)
			.then((res) => {
				const { data } = res
				getActivityLog()
				return { status: 200, data: data?.data }
			})
			.catch((err) => {
				return { status: 404, data: err.message }
			})
	}

	return (
		<ActivityLogContext.Provider
			value={{ activitylogs, logdetails, getActivityLog, postActivityLog, putActivityLog, deleteActivityLog }}
			{...props}
		/>
	)
}

export default ActivityLogProvider
